import { render, staticRenderFns } from "./IslamicFinanceForm.vue?vue&type=template&id=cabfa402"
import script from "./IslamicFinanceForm.vue?vue&type=script&lang=js"
export * from "./IslamicFinanceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cabfa402')) {
      api.createRecord('cabfa402', component.options)
    } else {
      api.reload('cabfa402', component.options)
    }
    module.hot.accept("./IslamicFinanceForm.vue?vue&type=template&id=cabfa402", function () {
      api.rerender('cabfa402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/IslamicFinanceForm.vue"
export default component.exports